import PropTypes from "prop-types";
import * as React from "react";
import { Filter } from "react-admin";
import FilterInput from "./FilterInput";
export const FilterToolbar = (props: any) => {
  return (
    <Filter style={{ marginTop: 15, marginBottom: 10 }} {...props}>
      {props?.dataSource?.map?.((input, index) => (
        <FilterInput key={index + "_filter_input_key"} alwaysOn {...input} />
      ))}
    </Filter>
  );
};
FilterToolbar.prototype = {
  dataSource: PropTypes.array.isRequired,
  defValue: PropTypes.any,
  ...Filter.prototype,
};
export default FilterToolbar;
